<div class="graybackgroundclr">
  <div class="container col-lg-9 m-auto pt-4">
    <h1 class="text-center mb-4 font44 semi-bold mbuseraccount">
      User Account Settings
    </h1>
    <form class="pb-3">
      <div class="row col-sm-12 px-0 m-0 mbflex">
        <div class="col-sm-6">
          <div class="mb-2 col-12 d-flex p-0 mb-3 mbblockalign">
            <label
              class="
                col-sm-4 col-12
                text-right
                pt-1
                pl-0
                labelfnt
                semi-bold
                lablembalign
              "
              >Name
            </label>
            <div class="col-sm-8 col-12 d-flex p-0">
              <div class="col-6 pl-0 pr-1 textboxmbalign">
                <input
                  type="text"
                  name="firstname"
                  class="form-control inputfnt"
                  value="{{ userObj.fName }}"
                  readonly
                />
              </div>
              <div class="col-6 pl-1 pr-0 textboxmbalign">
                <input
                  type="text"
                  name="lastname"
                  class="form-control inputfnt"
                  value="{{ userObj.lName }}"
                  readonly
                />
              </div>
            </div>
          </div>
          <div
            *ngIf="emailFieldShow === false"
            class="mb-2 col-12 d-flex p-0 mb-3 mbblockalign"
          >
            <label
              class="
                col-sm-4 col-12
                text-right
                pt-1
                labelfnt
                pl-0
                semi-bold
                lablembalign
              "
              >Email Address</label
            >
            <div class="col-sm-8 col-12 p-0 textboxmbalign btn-bg-none">
              <input
                type="text"
                name="emailaddress"
                class="form-control inputfnt"
                id="emailRead"
                [(ngModel)]="userObj.initialEmail"
                #initialEmail="ngModel"
                email
                pattern="^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)\.*$"
              />
              <div
                [hidden]="
                  initialEmail.valid ||
                  initialEmail.pristine ||
                  !initialEmail.errors.pattern
                "
                class=""
              >
                <div class="posabs alertMsg">Enter valid email</div>
              </div>
              <div *ngIf="disableEmailUser === false">
                <button
                  *ngIf="showConfirmMail === false"
                  class="changefnt pinkclr"
                  (click)="changemailid()"
                  [disabled]="disableEmail"
                >
                  Change email address
                </button>
              </div>
            </div>
          </div>
          <div *ngIf="showConfirmMail">
            <div class="mb-2 col-12 d-flex p-0 mb-3 mbblockalign">
              <label
                for="confirmemailaddress"
                class="
                  col-sm-4 col-12
                  pl-0
                  text-right
                  pt-1
                  labelfnt
                  semi-bold
                  lablembalign
                "
                >Confirm Email Address</label
              >
              <div class="col-sm-8 col-12 p-0 textboxmbalign">
                <input
                  type="text"
                  class="form-control inputfnt"
                  name="confirmemailaddress"
                  id="confirmEmailRead"
                  [(ngModel)]="userObj.confirmEmailId"
                  (ngModelChange)="saveBtnEnable('mail')"
                  #confirmEmailId="ngModel"
                  required
                  pattern="^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)\.*$"
                />

                <div
                  [hidden]="
                    (confirmEmailId.valid || confirmEmailId.pristine) &&
                    (userObj.initialEmail === userObj.confirmEmailId ||
                      confirmEmailId.invalid)
                  "
                  class=""
                >
                  <div class="posabs alertMsg">Confirm email should match</div>
                </div>
              </div>
            </div>
          </div>

          <div
            *ngIf="passwordFieldShow === false"
            class="mb-2 col-12 d-flex p-0 mb-3 mbblockalign"
          >
            <label
              class="
                col-sm-4 col-12
                text-right
                pt-1
                labelfnt
                pl-0
                semi-bold
                lablembalign
              "
            >
              Password
            </label>
            <div class="col-sm-8 col-12 p-0 textboxmbalign btn-bg-none">
              <input
                type="password"
                name="Password"
                id="passwordRead"
                [(ngModel)]="userObj.password"
                #password="ngModel"
                class="form-control inputfnt"
                required
                minlength="8"
                pattern="(?=.*\d)(?=.*[!@#$%^&*])(?=.*[A-Z]).{8,}"
              />
              <div *ngIf="disablePasswordUser === false">
                <button
                  *ngIf="showConfirmPassword === false"
                  [disabled]="disablePassword"
                  class="changefnt pinkclr"
                  (click)="changePassword()"
                >
                  Change password
                </button>
              </div>
              <div
                [hidden]="
                  !showConfirmPassword ||
                  password.valid ||
                  password.pristine ||
                  !password.errors.pattern
                "
                class=""
              >
                <div class="posabs" class="mb-2 alertMsg">
                  Password should contain at least 8 characters with 1
                  Uppercase, 1 special character and 1 number
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="showConfirmPassword">
            <div class="mb-2 col-12 d-flex p-0 mb-3 mbblockalign">
              <label
                class="
                  col-sm-4 col-12
                  text-right
                  pt-1
                  labelfnt
                  pl-0
                  semi-bold
                  lablembalign
                "
                >Confirm Password</label
              >
              <div class="col-sm-8 col-12 p-0 textboxmbalign">
                <input
                  type="password"
                  name="confirmePasswordaddress"
                  [(ngModel)]="userObj.confirm_password"
                  #confirm_password="ngModel"
                  class="form-control inputfnt"
                  (input)="saveBtnEnable('password')"
                  id="confirmPasswordRead"
                  required
                  minlength="8"
                  pattern="(?=.*\d)(?=.*[!@#$%^&*])(?=.*[A-Z]).{8,}"
                />
                <div
                  [hidden]="
                    (confirm_password.valid || confirm_password.pristine) &&
                    (userObj.password === userObj.confirm_password ||
                      confirm_password.invalid)
                  "
                  class=""
                >
                  <div class="posabs alertMsg">
                    Confirm password should match
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            *ngIf="phoneNumberFieldShow === false"
            class="mb-2 col-12 d-flex p-0 mb-3 mbblockalign"
          >
            <label
              class="
                col-sm-4 col-12
                text-right
                pt-1
                labelfnt
                pl-0
                semi-bold
                lablembalign
              "
            >
              Phone Number</label
            >
            <div class="col-sm-8 col-12 p-0 textboxmbalign btn-bg-none">
              <div class="d-flex">
                <div class="col-2 pl-0 pr-1">
                  <input
                    type="tel"
                    name="PhoneNumber"
                    value="+1"
                    class="form-control inputfnt"
                    readonly
                  />
                </div>
                <div class="col-10 pl-1 pr-0">
                  <input
                    type="tel"
                    id="txtnumber"
                    name="PhoneNumber"
                    appPhoneNumber
                    [(ngModel)]="userObj.phone"
                    (paste)="onPhPaste($event)"
                    #phone="ngModel"
                    minlength="12"
                    maxlength="12"
                    class="form-control inputfnt"
                  />
                  <!-- (keydown)="numberValidation($event, 'phone')"-->
                </div>
              </div>
              <div *ngIf="disablePhoneUser === false">
                <button
                  *ngIf="confirmPhoneNum === false"
                  class="changefnt pinkclr btnbackground"
                  [disabled]="disablePhone"
                  (click)="changePhoneNum()"
                >
                  Change phone number
                </button>
              </div>
            </div>
          </div>
          <div *ngIf="confirmPhoneNum" class="d-flex">
            <div class="mb-2 col-12 d-flex p-0 mb-3 mbblockalign">
              <label
                class="
                  col-4
                  text-right
                  pt-1
                  labelfnt
                  semi-bold
                  pl-0
                  lablembalign
                "
                >Confirm Phone Number</label
              >
              <div class="col-sm-8 col-12 p-0 textboxmbalign">
                <div class="d-flex">
                  <div class="col-2 pl-0 pr-1">
                    <input
                      type="tel"
                      name="ConfirmPhoneNumber"
                      value="+1"
                      class="form-control inputfnt"
                      readonly
                    />
                  </div>
                  <div class="col-10 pl-1 pr-0">
                    <input
                      type="tel"
                      name="ConfirmPhoneNumber"
                      id="confirmTxtnumber"
                      appPhoneNumber
                      [(ngModel)]="userObj.confirm_phone"
                      #confirm_phone="ngModel"
                      class="form-control inputfnt"
                      (input)="saveBtnEnable('mobile')"
                      (paste)="onPaste($event)"
                      minlength="12"
                      maxlength="12"
                    />
                    <!-- (keydown)="numberValidation($event, 'confirm_phone')" -->
                    <div
                      [hidden]="
                        (confirm_phone.valid || confirm_phone.pristine) &&
                        (userObj.phone === userObj.confirm_phone ||
                          confirm_phone.invalid)
                      "
                      class=""
                    >
                      <div class="posabs alertMsg">
                        Confirm phone no should match
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="row col-sm-12 px-0 m-0 mbflex"
          *ngIf="browserValue === 'Mob'"
        >
          <div class="col-sm-6 col-12">
            <div class="col-8 p-0">
              <button
                type="button"
                [disabled]="saveButton"
                id="saveChangesBtn"
                href="javascript:void(0)"
                (click)="changeAccount($event)"
                class="btn disabledButton signinpad mt-3 font19 mbsave mb-4"
                [ngClass]="{ sectbtn: ngClass }"
              >
                GENERATE OTP
              </button>

              <button
                type="button"
                id="saveChangesBtn"
                href="javascript:void(0)"
                class="btn signinpad mt-3 font19 mbsave mb-4"
                [ngClass]="{ sectbtn: ngClass }"
                style="margin-left: 10px; background: deeppink; color: white"
                (click)="closeAll()"
              >
                CANCEL
              </button>
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="row">
            <div class="mb-2 col-12 d-flex mb-3">
              <label
                class="
                  col-4
                  text-right
                  pt-1
                  mbopt
                  labelfnt
                  pl-0
                  semi-bold
                  mbalign
                "
              >
                Opt-in Alerts
              </label>
              <div class="col-sm-8 col-12 p-2">
                <div class="col-12 p-0 mb-2 d-flex">
                  <font class="minwd250 trustfnt">Trusted Partner Offers</font>
                  <span class="toggle-switch pt-1"
                    ><img
                      src="assets/images/enabled.svg"
                      class="enableImg d-block"
                      id="enableImgeId"
                      (click)="enableClick()"
                      width="35"
                    />
                    <img
                      src="assets/images/disabled.svg"
                      class="disableImg d-none"
                      (click)="disEnableClick()"
                      id="disableImgeId"
                      width="35"
                    />
                  </span>
                </div>
                <div class="col-12 p-0 mb-2 d-flex">
                  <font class="minwd250 trustfnt"
                    >Energy Saving Newsletters
                  </font>
                  <span class="toggle-switch pt-1"
                    ><img
                      src="assets/images/enabled.svg"
                      class="enableImg d-block"
                      id="enableImgeIdsec"
                      (click)="enableClicksec()"
                      width="35"
                    />
                    <img
                      src="assets/images/disabled.svg"
                      class="disableImg d-none"
                      (click)="disEnableClicksec()"
                      id="disableImgeIdsec"
                      width="35"
                    />
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row col-sm-12 px-0 m-0 mbflex" *ngIf="browserValue === 'Web'">
        <div class="col-sm-6 col-12">
          <div class="col-8 offset-4 p-0">
            <button
              type="button"
              [disabled]="saveButton"
              id="saveChangesBtn"
              href="javascript:void(0)"
              (click)="changeAccount($event)"
              class="btn disabledButton signinpad mt-3 font19 mbsave mb-4"
              [ngClass]="{ sectbtn: ngClass }"
            >
              GENERATE OTP
            </button>
            <button
              type="button"
              id="saveChangesBtn"
              href="javascript:void(0)"
              class="btn signinpad mt-3 font19 mbsave mb-4"
              [ngClass]="{ sectbtn: ngClass }"
              style="margin-left: 10px; background: deeppink; color: white"
              (click)="closeAll()"
            >
              CANCEL
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
<div
  class="modal fade mbpadd"
  *ngIf="changeEmail"
  id="emailModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content bodyradius">
      <div class="modal-body">
        <button
          type="button"
          class="close videoclose closeBorder"
          data-dismiss="modal"
          aria-label="Close"
        >
          <div class="float-right mr-3 mt-1" (click)="closeConfirmAddress()">
            <img src="assets/images/editchart-close.svg" width="20" />
          </div>
        </button>
        <div class="p-4">
          <div class="mt-4 text-center">
            <h6 class="font20 font-weight-bold-calibre">
              {{ getOTPMessage() }}
            </h6>
            <div class="text-left m-auto pt-2">
              <a class="font20 font-weight-normal-calibre mbupdate"
                >We want to make sure that you desired to have your profile
                updated.</a
              >
            </div>
          </div>

          <div class="col-lg-12 mt-4 p-0">
            <input
              type="text"
              class="
                font15
                font-weight-normal-calibre
                col-lg-12
                form-control
                p-2
                resizeposition
              "
              name="newEmailOTP"
              [(ngModel)]="userObj.newOtp"
              value=""
              placeholder="ENTER TEMPORARY OTP SENT TO: {{ userObj.newEmail }}"
              (blur)="checkNewField(this)"
              (change)="checkNewField(this)"
            />
          </div>

          <div class="text-center mt-1 p-0">
            <button
              class="font15 linhgt19 font-weight-normal-calibre btnbackgroundp"
              href="javascript:void(0)"
              [disabled]="resendOtpPsw"
              (click)="resendOtp()"
            >
              Resend Temporary Password
            </button>
          </div>
          <div class="m-auto text-center">
            <button
              type="button"
              [disabled]="!sendEmailEnable"
              [ngClass]="{ sectbtn: sendEmailEnable }"
              class="btn disabledButton signinpad mt-4 font13 mb-4"
              (click)="saveChanges()"
            >
              SAVE CHANGES
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- // Password popup -->
<div
  class="modal fade mbpadd"
  id="passwordSuccessModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content bodyradius acknowledge">
      <div class="modal-body">
        <button
          type="button"
          class="close videoclose closeBorder closeVla"
          data-dismiss="modal"
          aria-label="Close"
        >
          <div class="float-right mr-1 mt-0" (click)="closeConfirmAddress()">
            <img src="assets/images/editchart-close.svg" width="20" />
          </div>
        </button>
        <div class="pl-4 pb-4 pr-4">
          <div class="mt-0 text-center">
            <!-- <h6 class="font20 font-weight-bold-calibre">VERIFY TEMPORARY PASSWORD</h6> -->
            <div class="text-center m-auto pt-0">
              <a class="font20 font-weight-normal-calibre mbupdate">
                <img
                  src="assets/images/AcknowledgementPassword.svg"
                  width="200"
                />
              </a>
            </div>
            <div class="text-center m-auto pt-2">
              <a class="font23 font-weight-normal-calibre mbupdate">
                Your password has been <br />
                successfully changed!
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Email changes -->
<div
  class="modal fade mbpadd"
  id="emailSuccessModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content bodyradius acknowledge">
      <div class="modal-body">
        <button
          type="button"
          class="close videoclose closeBorder closeVla"
          data-dismiss="modal"
          aria-label="Close"
        >
          <div class="float-right mr-1 mt-0" (click)="closeConfirmAddress()">
            <img src="assets/images/editchart-close.svg" width="20" />
          </div>
        </button>
        <div class="pl-4 pb-4 pr-4">
          <div class="mt-0 text-center">
            <!-- <h6 class="font20 font-weight-bold-calibre">VERIFY TEMPORARY PASSWORD</h6> -->
            <div class="text-center m-auto pt-0">
              <a class="font20 font-weight-normal-calibre mbupdate">
                <img src="assets/images/acknowledgeEmail.svg" width="200" />
              </a>
            </div>
            <div class="text-center m-auto pt-2">
              <a class="font23 font-weight-normal-calibre mbupdate">
                Your email address has been<br />
                successfully changed!
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Mobile number -->
<div
  class="modal fade mbpadd"
  id="mobileSuccessModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content bodyradius acknowledge">
      <div class="modal-body">
        <button
          type="button"
          class="close videoclose closeBorder closeVla"
          data-dismiss="modal"
          aria-label="Close"
        >
          <div class="float-right mr-1 mt-0" (click)="closeConfirmAddress()">
            <img src="assets/images/editchart-close.svg" width="20" />
          </div>
        </button>
        <div class="pl-4 pb-4 pr-4">
          <div class="mt-0 text-center">
            <!-- <h6 class="font20 font-weight-bold-calibre">VERIFY TEMPORARY PASSWORD</h6> -->
            <div class="text-center m-auto pt-0">
              <a class="font20 font-weight-normal-calibre mbupdate">
                <img src="assets/images/AcknowledgePhone.svg" width="200" />
              </a>
            </div>
            <div class="text-center m-auto pt-2">
              <a class="font23 font-weight-normal-calibre mbupdate">
                Your mobile number has been<br />
                successfully changed!
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="backdrop" [ngStyle]="{ display: display }"></div>
<div class="modal" tabindex="-1" role="dialog" [ngStyle]="{ display: display }">
  <div class="modal-dialog" role="document">
    <div class="modal-content m-auto blockbg boxclr text-center">
      <div class="modal-body">
        <!-- <div class="mt-5"> -->
        <div class="">
          <img src="assets/images/loading.gif" />
          <p class="text-center tipmes font15">
            Please wait for a few seconds...
          </p>
        </div>
        <!-- </div> -->
      </div>
    </div>
    <!-- /.modal-content -->
  </div>
  <!-- /.modal-dialog -->
</div>
<!-- <ngx-spinner></ngx-spinner> -->
